export function StudioAppHeader() {
  return (
    <header
      data-studio-header=""
      className="flex-shrink-0 h-14 border-b border-border/40 bg-bgPage/95 backdrop-blur-sm z-[100] pl-0 md:pl-14"
    >
      <div className="h-full flex items-center px-4">
        <div
          style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}
        >
          <span
            style={{
              fontFamily: "'Geist Sans', sans-serif",
              fontWeight: 700,
              fontSize: "18px",
              letterSpacing: "-0.01em",
              color: "#ffffff",
              lineHeight: 1,
            }}
          >
            Footwear Studio
          </span>

          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "'Geist Sans', sans-serif",
              fontWeight: 500,
              fontSize: "9px",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "#5cc8f5",
              border: "1px solid rgba(92,200,245,0.55)",
              borderRadius: "9999px",
              padding: "3px 9px",
              lineHeight: 1,
              height: "fit-content",
            }}
          >
            Module
          </span>
        </div>
      </div>
    </header>
  );
}
